// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"d39f2b55","453":"6d1cba2b","519":"4108be78","599":"a63b0d4b","661":"8fd22b57","713":"34891eb7","720":"c6a1c84a","751":"dae67db7","759":"7d4139ef","781":"9358d2bf","801":"7e563a51","830":"e904d1ea","851":"9b9166e8","914":"6ee96b7e","980":"6edd8914"}[chunkId] + ".chunk.js";
};